<template>
  <div class="container-cidades">
    <br>
    <div class="row">
       <h4 class="col-sm-12">Fotos do imóvel</h4>

          <div class="form-group col-sm-5">
           
          <label>Selecione uma foto para envio:</label>
          <input type="file" name="imagem" class="form-control" @change="onFileSelected" multiple />
        </div>

          <button @click.prevent.stop="add" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ENVIAR</button>


         

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

 <h2 v-if="uploading" class="col-sm-12">Enviando... {{subindo + 1}} / {{selecionadas.length }}<br><br></h2>
    </div><!-- row -->


    <div class="row">

<draggable v-model="fotos" class="row" group="fotos" @start="drag=true" @end="drag=false"  @change="ordernar">
      <div class="card col-sm-4" v-for="(item, index) in fotos" :key="item.index" >
        <img style="cursor:pointer;"  @click="openGallery(index)" :src="'https://www2.royaljardim.com.br/sistema/fotos/'+item.url" class="card-img-top cortar" alt="..." />
        <div class="card-body">
          <h5 class="card-title"></h5>
          <p class="card-text"></p>
          <button v-if="getPermissao() == 1" class="btn btn-danger btn-block" @click="deleteFoto(item.id,index)">EXCLUIR</button>

<div class="form-group  form-check">
           <input type="checkbox" name="capa" value="Sim" :checked="item.capa == 'Sim'"  class="form-check-input" @change="capa(item.id,$event)">
           <label class="form-check-label"   >Capa</label>
            
        </div>


        </div>
      </div><!-- col 4 -->
</draggable>

      <LightBox
        ref="lightbox"
        :media="media"
        :show-caption="false"
        :show-light-box="false"
        
      />

    </div><!-- row cards -->



  </div>
</template>
<style>
.cortar{width: 358px; height: 200px; object-fit: cover;}
</style>

<script>
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
import axios from 'axios'
import LightBox from 'vue-image-lightbox'
import draggable from 'vuedraggable'

export default {
  name: 'Foto',
  components: { LightBox,draggable},
  props:['imovel'],
  data(){
      return {
          fotos:[],
          selectedFile:null,
          selecionadas:[],
          subindo:0,
          uploading:false,
          loading: false,
          media:[]
      }
  },
 

methods:{
  ordernar(){
    let pos = 1;
    let ordem = [];
          this.fotos.forEach(function(foto){
         
            let item = {'FOT_ID' : foto.id, "FOT_POSICAO" : pos };
            pos++;
            ordem.push(item);
          });

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/ordenarFoto',ordem)
          .then(response => console.log(response))
          .catch(response => console.log(response))
  },
   getPermissao(){
    return  sessionStorage.getItem('imobiliaria');
  },
  openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },

    add(){
          this.loading = true;
          this.uploading = true;
          let fm = new FormData();
          fm.append('image',this.selectedFile,this.selectedFile.name);
          fm.append('id',this.imovel);
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novaFoto',fm)
          .then(res => {this.fotos.push(res.data); this.checkCompleted()})
          .catch(response => console.log(response))
         
      },
      checkCompleted(){
        this.subindo++;
        if(this.subindo < this.selecionadas.length){
          this.selectedFile = this.selecionadas[this.subindo];
          this.add();
        }else{
          this.loading = false;
          this.uploading = false;
        }
      },

      onFileSelected(event){
       this.selectedFile = event.target.files[0];
       this.selecionadas = event.target.files;
      },

       deleteFoto(id,index){
          
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/deleteFoto',{id:id})
          .then( () =>  this.fotos.splice(index, 1))
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },
    getFotos(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getFotos',{imovel:this.imovel})
          .then(response => {
            response.data.forEach(item => {this.fotos.push({id:item.FOT_ID, url:item.FOT_NOME,capa:item.FOT_CAPA})});
            response.data.forEach(item => {this.media.push({thumb:'https://www2.royaljardim.com.br/sistema/fotos/' +item.FOT_NOME,
            src:'https://www2.royaljardim.com.br/sistema/fotos/' +item.FOT_NOME, })});
            })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    capa(id,value){
    let check = (value.target.checked) ? "Sim":'Não';
       this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/capaFoto',{id:id,checked:check})
          .then( response =>  console.log(response))
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    }
  

},
  
  mounted () {
  this.getFotos();
  
  }



}
</script>